import { CNPJMask } from "@/components/mask/CNPJMask";
import { formatCNPJ } from "@/utils/cnpjUtils";
import { TextField } from "@mui/material";
import { useEffect, useState } from "react";

export function CompaniesForm({ values, setValues }: any) {
  const [errors, setErrors] = useState<Record<string, string>>({});

  // Field-specific validators (called on blur)
  const validateName = () => {
    if (!values.name?.trim()) {
      setErrors(prev => ({ ...prev, name: "Nome é obrigatório" }));
    } else {
      setErrors(prev => ({ ...prev, name: "" }));
    }
  };

  const validateCNPJ = () => {
    if (!values.cnpj?.trim()) {
      setErrors(prev => ({ ...prev, cnpj: "CNPJ é obrigatório" }));
    } else if (values.cnpj.replace(/\D/g, "").length < 14) {
      setErrors(prev => ({ ...prev, cnpj: "CNPJ deve ter 14 números" }));
    } else {
      setErrors(prev => ({ ...prev, cnpj: "" }));
    }
  };

  const validateSocialReason = () => {
    if (!values.social_reason?.trim()) {
      setErrors(prev => ({ ...prev, social_reason: "Razão Social é obrigatória" }));
    } else {
      setErrors(prev => ({ ...prev, social_reason: "" }));
    }
  };

  const handleCNPJChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const maskedValue = e.target.value;
    const digits = maskedValue.replace(/\D/g, "");

    setValues({
      ...values,
      cnpj_formated: maskedValue,
      cnpj: digits,
    });
  };

  useEffect(() => {
    if (values.cnpj && !values.cnpj_formated) {
      const cnpjFormated = formatCNPJ(values.cnpj)
      setValues((prev: any) => ({
        ...prev,
        cnpj_formated: cnpjFormated,
      }));
    }
  }, [values.cnpj]);

  const isInvalid =
    values.cnpj &&
    values.cnpj.replace(/\D/g, "").length < 14;

  return (
    <>
      <TextField
        label="Nome"
        value={values.name || ""}
        onChange={(e) =>
          setValues({ ...values, name: e.target.value })
        }
        onBlur={validateName}
        error={!!errors.name}
        helperText={errors.name}
        required
        fullWidth
      />

      <TextField
        label="CNPJ"
        placeholder="00.000.000/0000-00"
        value={values.cnpj_formated || ""}
        onChange={handleCNPJChange}
        onBlur={validateCNPJ}
        error={isInvalid || !!errors.cnpj}
        helperText={errors.cnpj || (isInvalid ? "CNPJ deve ter 14 números" : "")}
        fullWidth
        required
        slotProps={{
          input: {
            inputComponent: CNPJMask as any,
          },
        }}
      />

      <TextField
        label="Razão Social"
        value={values.social_reason || ""}
        onChange={(e) =>
          setValues({ ...values, social_reason: e.target.value })
        }
        onBlur={validateSocialReason}
        error={!!errors.social_reason}
        helperText={errors.social_reason}
        required
        fullWidth
      />

      <TextField
        label="Código ERP"
        value={values.erp_code || ""}
        onChange={(e) =>
          setValues({ ...values, erp_code: e.target.value })
        }
        fullWidth
      />
    </>
  );
}